<div class="container-fluid p-0">
  <div class="row">
    <div class="col">
      <div class="container-fluid p-0" [formGroup]="materialTreeProtectionForm">
        <!-- <div class="row">
              <h2 class="">Species and Planting Materials required for "Target Property/Paddock"</h2>
            </div> -->
        <h4>Introduction</h4>
        <div class="row">
          <p class="mt-2">
            Fencing is likely required to protect young trees from vermin and
            stock alike. This form provides an estimate of fencing materials
            likely required to protect your trees.
          </p>
        </div>

        <div class="row">
          <p class="mt-1">
            In addition to fencing, browsing control can also be an effective
            means of protecting trees. For more information on browing control,
            please refer to this link:
          </p>
        </div>

        <div class="row mt-3">
          <h5 class="">User inputs</h5>
          <div class="grid grid-cols-2 gap-4">
            <div class="mb-2">
              <label for="chooseTheTypeOfFenceYouRequired" class="block text-sm font-medium text-gray-700 mb-2">Choose the type of fence you required
              </label>
              <select id="chooseTheTypeOfFenceYouRequired"
                      (change)="changeToFencingTypeHandler($event); passValuesToParent()"
                      class="custom-select" aria-label="Choose the type of fence you require">
                <option selected value="">-- Select --</option>
                @for (fenceType of fencingType; track fenceType) {
                  <option value="{{ fenceType }}">
                    {{ fenceType }}
                  </option>
                }
              </select>
            </div>
            <div class="mb-2">
              <label for="lengthOfFenceRequired" class="form-label">Length of Fence Required (m)</label>
              <input id="lengthOfFenceRequired" appNumbersOnlyInputDirective type="number" class="form-control"
                     (keyup)="inputChangePopulateFormDataHandler(); passValuesToParent()"
                     formControlName="lengthOfFenceRequired" />
            </div>
          </div>
        </div>

        @if (selectedFencingType) {
          <div [@inOutAnimation] class="row mb-4">
            <div class="grid grid-cols-2 gap-4">
              <div>
                <label for="lengthOfFenceRequired" class="form-label">Timing</label>
                <p>
                  {{ selectedFencingTypeDetails['Timing'] }}
                </p>
              </div>
              <div>
                <label class="form-label">Other consideration</label>
                <p>
                  {{
                    selectedFencingTypeDetails['Other Considerations']
                      ? selectedFencingTypeDetails['Other Considerations']
                      : 'N/A'
                  }}
                </p>
              </div>
            </div>

            <div class="mt-3 grid grid-cols-4 gap-4">
              <div class="d-none">
                <label for="postSpacing" class="form-label">Post Spacing (metres per post)</label>
                <input appNumbersOnlyInputDirective type="number" class="form-control" formControlName="postSpacing"
                       id="postSpacing" />
              </div>
              <div class="d-none">
                <label for="ratioStarPosts" class="form-label">Ratio Star Posts to Steel/Treated Pine</label>
                <input appNumbersOnlyInputDirective type="number" class="form-control" (keyup)="
                  inputChangePopulateFormDataHandler(); passValuesToParent()
                " formControlName="ratioStarPostToSteel" id="ratioStarPosts" />
              </div>
              <div class="d-none">
                <label for="standardWireRows" class="form-label">Standard Wire Rows Required (n)</label>
                <input appNumbersOnlyInputDirective type="number" class="form-control" (keyup)="
                  inputChangePopulateFormDataHandler(); passValuesToParent()
                " formControlName="standardWireRows" id="standardWireRows" />
              </div>

              <div class="d-none">
                <label for="barbWireRows" class="form-label">Barb Wire Rows Required (n)</label>
                <input appNumbersOnlyInputDirective type="number" class="form-control" (keyup)="passValuesToParent()"
                       formControlName="barbWireRows" id="barbWireRows" />
              </div>
            </div>
          </div>
        }
        @if (selectedFencingType) {
          <div [@inOutAnimation]>
            <h5 class="my-3">Summary</h5>
            <table class="table-fixed w-5/6">
              <thead>
              <tr class="border-b border-gray-300  h-8">
                <th class="pl-2 text-left w-60">Post Type:</th>
                <th class="text-left w-20">Star</th>
                <th class="text-left w-20">Steel/Wood</th>
              </tr>
              </thead>
              <tbody>
              <tr class="border-b border-gray-300  h-8">
                <td class="pl-2 w-60">Number Posts Required:</td>
                <td class="w-20">{{ summaryNumberOfRollsRequired['star'] | toPrecision }}</td>
                <td class="w-20">
                  {{ summaryNumberOfRollsRequired['steelWood'] | toPrecision }}
                </td>
              </tr>
              </tbody>
            </table>

            <table class="table-fixed w-5/6 my-2">
              <thead>
              <tr class="border-b border-gray-300  h-8">
                <th class="pl-2 text-left w-40">Wire type</th>
                <th class="text-left w-20">Standard Wire</th>
                <th class="text-left w-20">Barb Wire</th>
                <th class="text-left w-20">Wallaby Proof Mesh</th>
              </tr>
              </thead>
              <tbody>
              <tr class="border-b border-gray-300  h-8">
                <th class="pl-2 text-left w-60">Roll Length (m):</th>
                <td class="w-20">
                  {{
                    selectedFencingTypeDetails[
                      'Standard Wire Roll length - metres'
                      ] | toPrecision
                  }}
                </td>
                <td class="w-20">
                  {{
                    selectedFencingTypeDetails['Barb Wire Roll Length - metres']
                      | toPrecision
                  }}
                </td>
                <td class="w-20">
                  {{
                    selectedFencingTypeDetails[
                      'Wallaby Proof Mesh Roll Length - metres'
                      ] | toPrecision
                  }}
                </td>
              </tr>
              <tr class="border-b border-gray-300  h-8">
                <th class="pl-2 text-left w-60">Rolls Required:</th>
                <td class="w-20">
                  {{ summaryNumberOfRollsRequired['standarddWire'] | toPrecision }}
                </td>
                <td class="w-20">{{ summaryNumberOfRollsRequired['barbWire'] | toPrecision }}</td>
                <td class="w-20">
                  {{
                    summaryNumberOfRollsRequired['wallabyProofMesh'] | toPrecision
                  }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        }
        <div class="row"></div>
      </div>
    </div>
  </div>
</div>
